
import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";



const XmlResults = () => {

    const [validated, setValidated] = useState(false);
    const [textArea, setTextArea] = useState("")
    const [isLoading, setIsLoadinig] = useState(false);





    return (
        <>
            <div className="main">
                <div id="Sportbook">
                    <Toaster></Toaster>
                    {isLoading && <Loader spinner={true} visible={isLoading} />}
                    <div className="container">
                        <div className="card-deck row">
                            <div className="col-md-6 subcard" style={{}}>
                                <h4 className="mb-4">Import results via XML</h4>
                                <Form noValidate validated={validated} >
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Control as="textarea" rows={3} value={textArea} onChange={(e) => setTextArea(e.target.value)} />
                                    </Form.Group>
                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        style={{ width: "100%" }}
                                        type="submit"
                                    >
                                        Calculate the results
                                    </Button>
                                </Form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default XmlResults;
